import { useSelectedEnvironmentKey } from '@gonfalon/app-context/useSelectedEnvironmentKey';
import { msg } from '@gonfalon/messages/msg';
import { TextTruncator } from '@gonfalon/ui/TextTruncator';
import { Text } from '@launchpad-ui/components';

import { MetricLastSeenInfo } from '../../MetricLastSeenInfo';
import type { Metric } from '../../types';

import styles from './MetricsSearch.module.css';

interface MetricItemContentProps {
  metric: Metric;
  scopeByEnvironment?: boolean;
}

export function MetricItemContent({ metric, scopeByEnvironment }: MetricItemContentProps) {
  const selectedEnvironmentKey = useSelectedEnvironmentKey();
  return (
    <div className={styles.detailedListItem}>
      <div className={styles.detailedListItemContent}>
        <Text slot="label" className={styles.textTruncator}>
          <TextTruncator>{metric.name}</TextTruncator>
        </Text>
        <Text slot="description">
          <MetricLastSeenInfo
            metric={metric}
            showEnvironment={false}
            fallback={msg('metrics.metricsSearch.notSeenRecently')}
            hideTooltip
            scopedToEnvironment={scopeByEnvironment ? selectedEnvironmentKey : undefined}
          />
        </Text>
      </div>
    </div>
  );
}
